import { Color } from 'three';

/**
 * The prototype's colour vocabulary, in one place.
 *
 * Derived from the requirement document's colour roles (§12): safe gates read
 * white/green, danger reads red/violet, "just" windows glow blue-white, and the
 * board sits on near-black. The Unity build's cyan-teal presentation is kept as
 * the world's base hue so the two look like the same game.
 *
 * Values are linear-ish authoring colours; the renderer tone-maps on output.
 */
export const Palette = {
  /** Scene clear colour. Not pure black: a trace of blue keeps bloom from looking grey. */
  space: new Color(0x000208),
  /** Exponential depth fog. Matches `space` so distance reads as dissolution. */
  fog: new Color(0x00040c),

  nebulaWarm: new Color(0x2a1040),
  nebulaCool: new Color(0x07323d),

  starCool: new Color(0xbcd8ff),
  starWarm: new Color(0xffd9b0),
  starPale: new Color(0xffffff),

  mandalaCore: new Color(0xd8feff),
  mandalaMid: new Color(0x14e0d0),
  mandalaEdge: new Color(0x8b5cf6),

  ringCool: new Color(0x1fd6c8),
  ringWarm: new Color(0x7b5cff),

  rippleSafe: new Color(0x5ffbe0),
  rippleDanger: new Color(0xff2f6d),
  rippleDrift: new Color(0x8f7bff),
} as const;
